import { CardSection, CardSubSection } from '@side/pantry';
import { BuyerAgreementSection } from './BuyerAgreementSection';
import { BuyersAutocomplete } from './BuyerDetailsSection/BuyersAutocomplete';

export const ExistingBuyerCardSections = () => (
  <>
    <CardSection cardTitle="Buyer">
      <CardSubSection>
        <BuyersAutocomplete />
      </CardSubSection>
    </CardSection>
    <CardSection cardTitle="Buyer Agreement">
      <CardSubSection>
        <BuyerAgreementSection />
      </CardSubSection>
    </CardSection>
  </>
);
